import Api from './Api'
import {store} from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}

export default {
  async getSystems (deleted) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/systems?deleted=${deleted}`)
  },
  async getSystemStatuses () {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/system_statuses`)
  },
  async getSystem (id) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/systems/${id}`)
  },
  async saveSystem (system, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''

    return new Api().put(`/admin/api/v1/orgs/${getOrgId()}/systems${qualifier}`, system)
  },
  async deleteSystem (systemId) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/systems/${systemId}`, {deleted: true})
  },
  async toggleSystemEnabled (systemId, pollEnabled) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/systems/${systemId}`, {pollEnabled})
  },
  async getDocSchedules (systemId) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/systems/${systemId}/poll_schedules`)
  },
  async getDocSchedulesForTypeCode (typecode) {
    return new Api().get('/admin/api/v1/poll_schedules?system_type=' + typecode)
  },
  async saveDocSchedulesForSystemId (systemId, docSchedules) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/systems/${systemId}/poll_schedules`, docSchedules)
  },
  async getSystemDataEntrySections (systemId) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/systems/' + systemId + '/data_entry_sections')
  },
  async getDataEntrySectionsForTypeCode (type) {
    return new Api().get('/admin/api/v1/data_entry_sections?system_type=' + type)
  },
  async getTypeCodes () {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/type_codes`)
  },
  async getAllTypeCodes () {
    return new Api().get(`/admin/api/v1/type_codes`)
  },
  async getNewSystem (typecode) {
    return new Api().get('/admin/api/v1/systems?system_type=' + typecode)
  },
  async validateSystem (system, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''

    return new Api().post('/admin/api/v1/orgs/' + getOrgId() + '/validate_system' + qualifier, system)
  },
  async validateSystemById (systemId, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''

    return new Api().post('/admin/api/v1/orgs/' + getOrgId() + '/validate_system/' + systemId + qualifier)
  },
  async getApiUrl (sysId, url) {
    const api = new Api(undefined, {
      orgId: getOrgId(),
      sysId: sysId
    });
    return api.get(url)
  },
  async postApiUrl (sysId, url) {
    const api = new Api(undefined, {
      orgId: getOrgId(),
      sysId: sysId
    });
    return api.post(url)
  },
  async getOrgLevelConfigs(systemType) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/extra_configs?system_type=' + systemType)
  },
  async saveOrgLevelConfigs(configs) {
    return new Api().put('/admin/api/v1/orgs/' + getOrgId() + '/extra_configs', configs)
  },
  async saveExtraConfigsStr(configs) {
    return new Api().put('/admin/api/v1/orgs/' + getOrgId() + '/extra_configs_str', configs)
  },
  async getExtraConfigValueForKey(key) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/extra_configs/' + key)
  },
  async getExtraConfigValues() {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/extra_configs')
  },
  async unDeleteSystem (systemId) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/systems/${systemId}`, {deleted: false})
  },
  async patchMultiple (patchList) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/systems`, patchList)
  },
  async saveAllowedTypes(allowedTypes) {
    return new Api().put('/admin/api/v1/orgs/' + getOrgId() + '/allowed_types', allowedTypes)
  },
  async getAllowedTypes() {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/allowed_types')
  },
}
